import { FC } from 'react';
import { Outlet } from 'react-router-dom';

import { Box } from '@mui/material';

import styles from './NoToolsLayout.module.scss';

export const NoToolsLayout: FC = () => (
  <Box className={styles.wrapper}>
    <Outlet />
  </Box>
);
